"use strict";

let helper = require('./helpers');


function getElementValue(selector) {
    const element = $(selector);
    let value;
    const role = element.attr('data-role');
    switch (role) {
        case 'combobox':
            value = element.data('kendoComboBox').value();
            break;
        case 'dropdownlist':
            value = element.data('kendoDropDownList').value();
            break;
        case 'datepicker':
            const dateTime = element.data('kendoDatePicker').value();
            if (dateTime === null) {
                value = dateTime;
            } else {
                const newDate = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
                value = newDate;
            }
            break;
        case 'datetimepicker':
            value = element.data('kendoDateTimePicker').value();
            break;
        case 'multiselect':
            value = element.data('kendoMultiSelect').value();
            break;
        case 'numerictextbox':
            value = element.data('kendoNumericTextBox').value();
            break;
        default:
            let type = element.attr('type');
            if (type === 'checkbox') {
                value = element.prop('checked');
            } else {
                value = element.val();
            }
            break;
    }
    return value;
}

window.changeMultiselectListWidth = function changeMultiselectListWidth(e) {
    //$(e.sender.element["0"]).data('kendoMultiSelect').list.width(640);
    let kElement = $(e.sender.element["0"]).data('kendoMultiSelect');
    kElement.list.width('auto');
    //if (kElement.list.width() < kElement.element.parent().width()) {
    //    kElement.list.width(kElement.element.parent().width());
    //}
};

window.clearInvalidDate = function clearInvalidDate(element) {
    return new Promise((resolve, reject) => {
        let picker;
        let dataRole = $(element).attr('data-role');
        if (dataRole === 'datepicker') {
            picker = $(element).data('kendoDatePicker');
        } else {
            picker = $(element).data('kendoDateTimePicker');
        }

        setTimeout(function () {
            let date = picker.value();
            if (date === null) {
                picker.value(null);
                resolve(true);
            } else {
                resolve(false);
            }
        }, 0);
    });
};

//Multiselect buttons
window.deselect = function deselect(id, detailsPage) {
    var element = $('#' + id).data('kendoMultiSelect');
    if (detailsPage) {
        element.value(element.value()[0]);
        element.close();
        element.trigger('change');
    } else {
        element.value([]);
        element.close();
        element.trigger('change');
    }
};
window.selectAll = function selectAll(id, objId) {
    var element = $('#' + id).data('kendoMultiSelect');
    var data = element.dataSource.data();
    var objId = objId === '' ? objId : '.' + objId;
    var valArray = [];
    data.forEach(function (item, i, data) {
        valArray.splice(0, 0, eval('item' + objId));
    });
    element.value(valArray);
   // element.value(data);
    element.close();
    element.trigger('change');
};


window.hideFullListCombo = function hideFullListCombo(e){    
    var id = e.sender.element['0'].id;
    if ($('#' + id).siblings().find('input').val() === '') {
        e.preventDefault();
        $('#' + id).data('kendoComboBox').close();
    }
};

window.addLoaderForButton = function addLoaderForButton(id) {
    $('#' + id).addClass('btn-load btn-load_small');
    $('#' + id).data('kendoButton').enable(false);
};

window.removeLoaderForButton = function removeLoaderForButton(id) {
    $('#' + id).removeClass('btn-load btn-load_small');
    $('#' + id).data('kendoButton').enable(true);
};

window.addLoaderForTextButton = function addLoaderForTextButton(id) {
    $('#' + id).addClass('btn-load btn-load_custom');
    $('#' + id).data('kendoButton').enable(false);
};

window.removeLoaderForTextButton = function removeLoaderForTextButton(id) {
    $('#' + id).removeClass('btn-load btn-load_custom');
    $('#' + id).data('kendoButton').enable(true);
};

function onFocusSelectText() {
    var input = $(this);
    clearTimeout(input.data("selectTimeId"));

    var selectTimeId = setTimeout(function () {
        input.select();
    });

    input.data("selectTimeId", selectTimeId);
}

function onBlurRemoveSelectText(e) {
    clearTimeout($(this).data("selectTimeId"));
}

//dropdown adjustments

window.changeDropDownListWidth = function changeDropDownListWidth(e) {
    let kElement = $(e.sender.element["0"]).data('kendoDropDownList');
    kElement.list.width('auto');
    if (kElement.list.width() < kElement.element.parent().width()) {
        kElement.list.width(kElement.element.parent().width());
    }
};

function setDropdownOptionLabel(id, optionObject) {
    let drop = $('#'+id).data('kendoDropDownList');

    drop.options.optionLabel = optionObject;
    drop.refresh();
    drop.select(drop.select());
}

function clearDropdownOptionLabel(id) {
    let input = $("#" + id).data("kendoDropDownList");

    let optionLabel = input.options.optionLabel;
    if (typeof optionLabel === "object") {
        let textField = input.options.dataTextField;
        let valueField = input.options.dataValueField;
        let newOptionLabel = {};
        newOptionLabel[textField] = " ";
        newOptionLabel[valueField] = "";

        input.options.optionLabel = newOptionLabel;
    } else {
        input.options.optionLabel = " ";
    }

    input.refresh();
    input.select(input.select());
}

function updateDropdownOptionLabel(id) {
    let input = $("#" + id).data("kendoDropDownList");
    clearDropdownOptionLabel(id);

    let optionLabel = input.options.optionLabel;
    if (typeof optionLabel === "object") {
        let textField = input.options.dataTextField;
        let valueField = input.options.dataValueField;
        let newOptionLabel = {};
        newOptionLabel[textField] = input.text();
        newOptionLabel[valueField] = input.value();

        input.options.optionLabel = newOptionLabel;
    } else {
        input.options.optionLabel = input.text();
    }
}

function initDropdownByValue(element, value, text, triggerChange) {
    return new Promise((resolve, reject) => {
        try {
            if (element.dataSource.beacon != undefined ||
                (value === null && element.dataSource.beacon === null) ||
                (value !== null && element.dataSource.beacon === value)) {
                resolve();
            } else {
                element.dataSource.beacon = value;

                element.dataSource.read()
                    .then(() => {
                        let data = element.dataSource.data();
                        element.value(value);
                        if (value != null) {
                            let item = data.find(x => x[element.options.dataValueField] == value);
                            if (item != undefined) {
                                let index = data.indexOf(item);
                                if (element.optionLabel.length > 0) {
                                    index += 1;
                                }
                                element.select(index);
                            } else {
                                element.select(-1);
                            }
                            if (triggerChange) {
                                element.trigger('change');
                            }
                        }
                        element.dataSource.beacon = undefined;
                        resolve();
                    });
            }
        }
        catch (e) {
            reject();
        }
    });
}


//#region combobox adjustments

window.changeComboBoxListWidth = function changeComboBoxListWidth(e) {
    $(e.sender.element["0"]).data('kendoComboBox').list.width('auto');
};

window.hideComboArrow = function hideComboArrow(id) {
    $('#' + id).siblings().css('padding-right', '0px');
    $('#' + id).siblings().find('.k-select').hide()
};

window.comboBoxDSrequestEnd = function comboBoxDSrequestEnd(e, comboBoxId) {
    console.log('comboBoxDSrequestEnd');
    var emptyValue = {
        Text: "",
        Value: null
    };
    $('#' + comboBoxId).data('kendoComboBox').dataSource.add(emptyValue);
};

function comboboxAsDropdown(id) {
    let input = $("#"+id).data("kendoComboBox").input;
    input.prop('readonly', 'readonly');
    input.bind("click", function () { $("#" + id).data("kendoComboBox").open(); });
}

function initComboByValue(element, value, text, triggerChange) {
    return new Promise((resolve, reject) => {
        try {
            element.text(text);
            element.dataSource.read()
                .then(() => {
                    let data = element.dataSource.data();
                    element.value(value);
                    if (value != null) {
                        let item = data.find(x => x[element.options.dataValueField] == value);
                        if (item != undefined) {
                            let index = data.indexOf(item);
                            element.select(index);
                        } else {
                            element.select(-1);
                            element.value('');
                            element.text('');
                        }
                        if (triggerChange) {
                            element.trigger('change');
                        }
                    }
                    resolve();
                });
        }
        catch (e) {
            reject();
        }
    });
}

function guaranteeReadOnOpen(openEvent, element) {
    if (element.xDataRead) {
        delete element.xDataRead;
        return;
    }

    if (element.dataSource.data().length == 0) {
        openEvent.preventDefault();
        element.dataSource.read().then(() => {
            element.dataRead = true;
            element.open();
        });
    }
}

function addEmptyItem(element) {
    element.dataSource.bind('requestStart', () => {
        element['x-empty-added'] = false;
    });

    if (element['x-empty-added']) {
        return;
    }

    let valueField = element.options.dataValueField;
    let textField = element.options.dataTextField;

    let emptyItem = {};
    emptyItem[valueField] = '';
    emptyItem[textField] = '';

    element['x-empty-added'] = true;
    element.dataSource.data().splice(0, 0, emptyItem);
}

//#endregion


function colorListbox(elementId) {
    for (let item of document.getElementById(elementId + "_listbox").querySelectorAll(".colored-item"))
    {
        let color = item.getAttribute("data-color");
        let elem = helper.findAncestor(item, "li");
        elem.style.backgroundColor = color;
    }
}

function colorTaglist(elementId) {
    for (let item of document.getElementById(elementId + "_taglist").querySelectorAll(".colored-tag"))
    {
        let color = item.getAttribute("data-color");
        let elem = helper.findAncestor(item, "li");
        elem.style.backgroundColor = color;
    }
}

function colorDropdown(elementId, color) {
    if (color == undefined) {
        let item = document.getElementById(elementId + "_listbox").querySelector("li.k-state-selected span");
        color = item.getAttribute("data-color");
    }

    let input = document.getElementById(elementId);
    let inputLabel = input.parentNode.querySelector(".k-input");
    inputLabel.style.backgroundColor = color;
}

function colorGridRows(elementId, colorWhite) {
    if (colorWhite === undefined || colorWhite === null) {
        colorWhite = false;
    }

    for (let item of document.getElementById(elementId).querySelectorAll("tr.colored-row")) {
        let color = item.getAttribute("data-color");
        if (colorWhite == false && (color === "#FFFFFF" || color === "#ffffff")) {
            //skip white color
        } else {
            item.style.backgroundColor = color;
        }
    }
}
function colorGridCells(elementId, colorWhite) {
    if (colorWhite === undefined || colorWhite === null) {
        colorWhite = false;
    }

    for (let item of document.getElementById(elementId).querySelectorAll("td.colored-cell"))
    {
        let color = item.getAttribute("data-color");
        if (colorWhite == false && (color === "#FFFFFF" || color === "#ffffff")) {
            //skip white color
        } else {
            item.style.backgroundColor = color;
        }
    }
}

function setInvalidStyle(elemId, valid) {
    if (valid) {
        $('[name="' + elemId + '_input"]').removeClass('input-invalid');
        $('label[for="' + elemId + '"]').removeClass('label-invalid');
    } else {
        $('[name="' + elemId + '_input"]').addClass('input-invalid');
        $('label[for="' + elemId + '"]').addClass('label-invalid');
    }
}

module.exports = {
    addLoaderForButton: addLoaderForButton,
    removeLoaderForButton: removeLoaderForButton,
    addLoaderForTextButton: addLoaderForTextButton,
    removeLoaderForTextButton: removeLoaderForTextButton,
    onFocusSelectText: onFocusSelectText,
    onBlurRemoveSelectText: onBlurRemoveSelectText,
    changeComboBoxListWidth: changeComboBoxListWidth,
    changeDropDownListWidth: changeDropDownListWidth,
    changeMultiselectListWidth: changeMultiselectListWidth,
    comboboxAsDropdown: comboboxAsDropdown,
    initDropdownByValue: initDropdownByValue,
    initComboByValue: initComboByValue,
    guaranteeReadOnOpen: guaranteeReadOnOpen,
    addEmptyItem: addEmptyItem,
    clearDropdownOptionLabel: clearDropdownOptionLabel,
    setDropdownOptionLabel: setDropdownOptionLabel,
    updateDropdownOptionLabel: updateDropdownOptionLabel,
    colorListbox: colorListbox,
    colorTaglist: colorTaglist,
    colorDropdown: colorDropdown,
    colorGridRows: colorGridRows,
    colorGridCells: colorGridCells,
    getElementValue: getElementValue,
    hideComboArrow: hideComboArrow,
    setInvalidStyle: setInvalidStyle,
    clearInvalidDate: clearInvalidDate
}
